<template>
    <div class="constructionRequirements" v-if="selectedProject">
        <div class="constructionRequirements__item" v-for="construction in selectedProject.constructions">
            <img class="constructionRequirements__logo" v-if="construction.logoPath" :src="construction.logoPath">
            <calculation-construction-feature-list
                    :features="construction.features"
                    v-if="construction.features.length"
            />
            <div class="constructionRequirements__container">
                <h3>{{construction.name}}</h3>
                <p v-if="construction.description">{{construction.description}}</p>
                <router-link
                        :to="{ name: 'calculation.construction', params: {constructionId: construction.id, projectSlug: selectedProject.slug}}"
                        class="button view-primary constructionRequirements__button"
                >
                    Vybrat a spočítat
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import CalculationConstructionFeatureList from './feature/ConstructionFeatureList';

    export default {
        name: 'CalculationConstructionList',
        components: {
            CalculationConstructionFeatureList
        },
        computed: {
            ...mapGetters('calculation', ['selectedProject']),
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/construction/ConstructionList.vue